
























































































































































import { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import { fixarCasasDecimais, formatarMoeda } from '@/shareds/formatadores'
import { Vue, Component } from 'vue-property-decorator'
const IMPORTACAO_DE_NOTA = 'IMPORTACAO_DE_NOTA'


@Component({
	components: {
	},
})
export default class DialogoDeDetalharProdutosDaImportacao extends Vue {
	mostrarDialogoDeDetalhesDoProduto = false
	produtoParaDetalhar: ProdutoDaImportacao | null = null
	importacaoDeNota: ImportacaoDeNota | null = localStorage[IMPORTACAO_DE_NOTA]
		? JSON.parse(localStorage[IMPORTACAO_DE_NOTA])
		: null

	fixarCasasDecimais = fixarCasasDecimais
	formatarMoeda = formatarMoeda

	mostrar(item: ProdutoDaImportacao){
		this.produtoParaDetalhar = item
		this.mostrarDialogoDeDetalhesDoProduto = true
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	formatarNumero(numero) {
		if(numero == null || numero == undefined) {
			return ''
		}
		return this.fixarCasasDecimais(parseFloat(numero), 2)
	}

	get podeCriarProduto() {
		return (this.importacaoDeNota && this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja &&
			this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
	}

}
